import * as React from 'react';
import * as _ from 'underscore';

import './SearchBox.css';

interface ISearchBoxProps {
    onSearchTriggered: (searchString: string) => void;
    onRef?: (searchBoxInstance: SearchBox | null) => void;
}

interface ISearchBoxState {
    voiceRecognitionActive: boolean;
    searchValue: string;
}

class SearchBox extends React.Component<ISearchBoxProps, ISearchBoxState> {
    private readonly inputRef: React.RefObject<HTMLInputElement>;
    private readonly throttledSearch: (() => void) & _.Cancelable;

    public constructor(props: ISearchBoxProps) {
        super(props);
        this.inputRef = React.createRef();

        this.throttledSearch = _.throttle(() => {
            this.proceedToTriggerSearch();
        }, 750, {leading: false});

        this.state = {
            voiceRecognitionActive: false,
            searchValue: ''
        };
    }

    public render() {
        return (
            <div className="SearchBox">
                <i className="SearchBox__icon SearchBox__icon--search material-icons" onClick={this.searchIconClicked}>search</i>
                <input
                    type="input"
                    placeholder="Search Tools"
                    className="SearchBox__input"
                    ref={this.inputRef}

                    onInput={this.inputChanged}
                    onKeyPress={this.keyPressed}
                    />

            </div>
        );
    }

    public componentDidMount() {
        if(this.props.onRef) {
            this.props.onRef(this);
        }
    }

    public componentDidUpdate(prevProps: ISearchBoxProps, prevState: ISearchBoxState) {
        if (this.state.searchValue !== prevState.searchValue) {
            if (this.inputRef.current) {
                this.inputRef.current.value = this.state.searchValue;
                this.throttledSearch();
            }
        }
    }

    public componentWillUnmount() {
        if(this.props.onRef) {
            this.props.onRef(null);
        }
    }

    // todo: does this need to be public?
    public focus() {
        if (this.inputRef.current) {
            this.inputRef.current.focus();
        }
    }

    private searchIconClicked = () : void => {
        if(!this.proceedToTriggerSearch()) {
            this.setState({
                searchValue: ''
            });
            this.focus();
        }
    };

    private inputChanged = () => {
        if (this.inputRef.current) {
            this.setState({
                searchValue: this.inputRef.current.value
            });
        }
    }

    private keyPressed = (event: any) : boolean => {
        if(event.key === "Enter") {
            this.throttledSearch.cancel();
            this.proceedToTriggerSearch();

            return false;
        }

        return true;
    }

    private proceedToTriggerSearch() : boolean {
        const charCount = this.state.searchValue.length;
        if(charCount > 2 || charCount === 0) {
            this.props.onSearchTriggered(this.state.searchValue);

            return true;
        } else {
            return false;
        }
    }
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/App/Blocks/SearchBox.tsx